import { TargetingStyle } from "./TargetingStyle";

import ListItem from "../ListItem/ListItem";
import { TargetMenu } from "../../data/TargetMenuData";
import React, { useState } from "react";
import { useInsertNewTarget } from "../../hooks/useManagement";
import { formatDate } from "../../utils/formatDate";
import { ShamsiToMiladi } from "../../utils/Miladi_To_Shamsi";
import Button from "../Button/Button";
import { DataPicker } from "../DataPicker/DataPicker";
import { InputField1 } from "../InputField1/InputField1";
import TargetHollTable from "../TargetHollTable/TargetHollTable";
const initvalue = {
  from_date: "",
  to_date: "",
  amount: "",
};
const Targeting = () => {
  const [form, setForm] = useState(initvalue);
  const { mutateAsync: insertTarget, isLoading } = useInsertNewTarget();

  const handleInsertTarget = async (datom) => {
    await insertTarget(datom).then(() => setForm(initvalue));
  };
  return (
    <>
      <TargetingStyle className="mt-3">
        <div className="row">
          <div className="col-lg-4 col-12">
            <DataPicker
              onChange={(e) => {
                setForm({ ...form, from_date: ShamsiToMiladi(formatDate(e)) });
              }}
              label="از تاریخ"
            />
          </div>
          <div className="col-lg-4 col-12">
            <DataPicker
              onChange={(e) =>
                setForm({ ...form, to_date: ShamsiToMiladi(formatDate(e)) })
              }
              label="تا تاریخ"
            />
          </div>
          <div className="col-lg-4 col-12">
            <InputField1
              label="تارگت کل"
              onChange={(e) => {
                setForm({ ...form, amount: e.target.value });
              }}
              value={form.target}
              placeholder="تارگت کل را وارد کنید"
            />
          </div>
          <div className="col-lg-1 col-12 mt-lg-1 mt-3">
            <Button
              bgColor="#009ef7"
              small="100%"
              color="#fff"
              onclick={() => handleInsertTarget(form)}
            >
              ثبت
            </Button>
          </div>
        </div>
      </TargetingStyle>
      <TargetHollTable />
    </>
  );
};

export default Targeting;
